module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showBlockUI) ? _c('BlockUI', {
    attrs: {
      "message": _vm.loadingMessage,
      "url": _vm.loadingImage
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "animated"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-303fff1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 563
// module chunks = 31